// @ts-nocheck
import buttonSizeVariants from "@insite/mobius/Button/buttonSizeVariants";
import { pxToRem } from "@toolkit/Framework/Common/Utilities/unitHelper";

/** buttonSizeVariants
 * ------------------------------------------------------------------------------------------
 * height: Height applied as "min-height" (px)
 * fontSize: Font size (px)
 * padding: CSS applied to the padding property "padding: [VALUE];"
 * icon: Icon size (px)
 * iconPadding: Spacing between the icon and the text (px)
 */

Object.assign(buttonSizeVariants, {
    small: {
        height: 36,
        fontSize: 13,
        padding: pxToRem(6, 24), // Store Custom Code
        icon: 20,
        iconPadding: 10, // Store Custom Code
        lineHeight: 1.28, // Store Custom Code
    },
    medium: {
        height: 40,
        fontSize: 14,
        padding: pxToRem(8, 24), // Store Custom Code
        icon: 22,
        iconPadding: 10, // Store Custom Code
        lineHeight: 1.28, // Store Custom Code
    },
    large: {
        height: 48,
        fontSize: 16,
        padding: pxToRem(10, 24), // Store Custom Code
        icon: 24,
        iconPadding: 10, // Store Custom Code
        lineHeight: 1.5, // Store Custom Code
    },
    xlarge: {
        height: 52, // Store Custom Code
        fontSize: 18,
        padding: pxToRem(10, 24), // Store Custom Code
        icon: 26,
        iconPadding: 12, // Store Custom Code
        lineHeight: 1.5, // Store Custom Code
    },
});
